<template>
    <div class="radio-list" >
        <label class="container" v-for="(item, index) in options"
                    :key="index"
                    @change="onChange()"
                    @click="selectItem(item, index)">
            <input type="radio" :checked="item.default" name="radio">
            <div class="checkmark"></div>
            <div class="title">{{ item.text }}</div>
        </label>
    </div>
</template>

<script>
export default {
    name: "RedioBox",
    props: {
        // v-model
        value: String,
        options: Array,
        inputId: String,
        disabled: Boolean,
    },
    data() {
        return {
            selected: true,
            content: this.value,
        };
    },
    methods: {
        onChange() {
            this.selected = !this.selected;

            // console.log(this.selected);
            this.$emit("input", this.selected);
            // this.$emit("update:selected", this.content);
        },
        selectItem: function(item) {
            console.log(item);
            this.$emit('onSelectedGender', item);
            // this.content = item.text;
            // this.itemSelected = item;
            // this.closeDropdown();

            // this.validateInput();
            // this.$emit('update:inputValue', this.content);

            // if (this.inputName == 'id_type') {

            //     this.$emit('selectType', item.value);
            //     this.$emit('onSelectedType', item);
            // }
            // if (this.inputName == 'race') {
            //     this.$emit('selectRace', item.value);
            //     this.$emit('onSelectedRace', item);
            // }

        },
    }
};
</script>

<style lang="scss">
// @import "@/style/_mixin.scss";
// @import "@/style/base/base.scss";
.radio-list {
    display: flex;
    width: 100%;
    // flex-direction: column;
    .container {
        display: block;
        position: relative;
        margin-bottom: 12px;
        cursor: pointer;
        padding-bottom: 12px;
        padding-top: unset;

        .title {
            // color: $light-slate-grey;
            padding-left: 15px;
        }
    }

    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 21px;
        width: 21px;
        background-image: url('../../assets/icon/ic-radio-inactive.svg');
        background-repeat: no-repeat;
    }

    .container input:checked ~ .checkmark {
        background-image: url('../../assets/icon/ic-radio-active.svg');
        background-repeat: no-repeat;
    }
}

</style>
